import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';

const actions = {
    getStage: {
        method: 'POST',
        isArray: true,
        url: `${BASE_PATH_API}/leasestages/:stage`,
        params: {
            '$count': true,
            '$top': '100'
        },
    },
    getLeaseIdsForStage: {
        method: 'GET',
        url: `${BASE_PATH_API}/leasestages`,
        params: {
            'minDaysLeft': 'minDaysLeft',
            'maxDaysLeft': 'maxDaysLeft'
        }
    }
};

export function LeaseStagesApi() {
    const service = createActions(actions);
    
    service.getStageLeases = function getStageLeases(params, leaseIds) {
        const query = params || {};
        
        if (query.DateRangeParameters && query.DateRangeParameters.length > 0) {
            query.DateRangeParameters = query.DateRangeParameters.join(',');
        }
        
        return service.getStage(query, leaseIds);
    };
            
    return service;
}
